import { Popconfirm as AntPopconfirm } from 'antd'

export default function Popconfirm ({ okButtonProps, cancelButtonProps, ...props }) {
  return (
    <AntPopconfirm
      {...props}
      okButtonProps={{ size: 'middle', ...okButtonProps }}
      cancelButtonProps={{ size: 'middle', ...cancelButtonProps }}
    />
  )
}
